import React from 'react'

import type { InputProps } from '@fourthwall/components'
import { Colors, Icon, Input } from '@fourthwall/components'
import { ResetIcon, SearchIcon } from '@fourthwall/icons'

export const SearchBar = ({ value, ...props }: InputProps) => (
  <Input
    size="small"
    leftIcon={SearchIcon}
    fullWidth
    value={value}
    actionIcon={value?.length ? <Icon component={ResetIcon} height={18} /> : undefined}
    actionIconColor={Colors.GS1000}
    {...props}
  />
)
